import React from 'react';
import { Company } from './company.model';

export const defaultCompanyContext = undefined as undefined;

export const CompanyContext = React.createContext<Company | undefined>(
  defaultCompanyContext
);
